import { render } from "./AllUsers.vue?vue&type=template&id=50610d84&scoped=true"
import script from "./AllUsers.vue?vue&type=script&lang=js"
export * from "./AllUsers.vue?vue&type=script&lang=js"

import "./AllUsers.vue?vue&type=style&index=0&id=50610d84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50610d84"]])

export default __exports__